import {
  AD_LABEL,
  AM_LABEL,
  PM_LABEL
} from '../constants/general';

export const isAvailableForSetNumber = (availabilityType, numberOfSet) => {
  switch (numberOfSet) {
    case AM_LABEL:
      return availabilityType === AD_LABEL || availabilityType === AM_LABEL;
    case PM_LABEL:
      return availabilityType === AD_LABEL || availabilityType === PM_LABEL;
    // if number of set is undefined we asume 'AD' and am or pm only availabilities should appear for all day sets 
    default:
      return true;
  }
};

export const generateGranularOptions = (employee,values) => {
  if (employee.availabilityType === AD_LABEL) {
    return [AD_LABEL, AM_LABEL, PM_LABEL].map(availabilityType => {
      const isSelected = values != null && values.some(val =>
        val.id === employee.value && val.availabilityType === availabilityType
      );
      return {
        ...employee,
        isSelected,
        availabilityType,
      }
    });
  }
  return [
    employee,
  ];
}

export const prepareAvailabilityRequestData = (employee, month, year) => {
  const availabilityRequestData = [];
  const hasAgent = employee.agents.length;
  const employeeName = employee.nickName
    ? employee.nickName
    : `${employee.firstName} ${employee.lastName}`;
  const employeeRequestData= {
    studioEmployeeId: employee.id,
    employeeName,
    email: employee.email,
    month,
    year,
    agentName: null,
  };
  if (hasAgent) {
    employee.agents.forEach(agent => {
      const agentName = `${agent.firstName} ${agent.lastName}`;
      availabilityRequestData.push({
        ...employeeRequestData,
        email: agent.email,
        agentName,
      });
    });
  } else {
    availabilityRequestData.push(employeeRequestData);
  }
  return availabilityRequestData;
}
